module.exports = __webpack_public_path__ + "img/jwgl-kbcx-jxbxs.6cc1bfc6.png";